import type { ChangelogEntry } from "../types";

/** VIB-2927: frilans på prosjekt (bak flagget feature_freelancer_projects). */
export const FRILANS_PA_PROSJEKT_2026_10: ChangelogEntry = {
  id: "2026-10-24-frilans-pa-prosjekt",
  date: "2026-10-24",
  title: "Frilansere kobles til prosjekter via budsjett og bilag",
  summary:
    "Velg frilanser på eksterne kostnadslinjer i Timetildeling og koble leverandører til frilansere fra bilagene. Profilen viser prosjektene frilanseren er brukt på. Ingen kost eller KPI endres.",
  sections: [
    {
      heading: "Inne på et prosjekt",
      items: [
        {
          title: "Frilanser på kostnadslinjer i Timetildeling",
          kind: "nytt",
          body: "Under «Vis kostnader» kan du velge frilanser på eksterne linjer. Frilansere med fagfelt som ligner linjen vises først, med dagspris og vurdering. Estimert kost på linjen endres ikke.",
          featureFlag: "feature_freelancer_projects",
        },
        {
          title: "Koble leverandør til frilanser fra bilag",
          kind: "nytt",
          body: "Under leverandørnavnet på en leverandørfaktura står «Koble til frilanser». Koblingen gjelder alle fakturaer fra leverandøren, også gamle og på andre prosjekter.",
          featureFlag: "feature_freelancer_projects",
        },
        {
          title: "Frilansere i Team & eierskap",
          kind: "nytt",
          body: "Frilanserne på prosjektet vises med rolle og fakturert beløp.",
          featureFlag: "feature_freelancer_projects",
        },
      ],
    },
    {
      heading: "Frilansere",
      items: [
        {
          title: "Prosjekter og «Sist brukt»",
          kind: "nytt",
          body: "Profilen viser prosjektene frilanseren er brukt på, med rolle, estimert kost per linje og fakturert. Lista har kolonnen «Sist brukt», og frilansere som er brukt regnes som testet.",
          featureFlag: "feature_freelancer_projects",
        },
        {
          title: "Leverandører",
          kind: "nytt",
          body: "Siden «Leverandører» viser leverandørene med fakturaer på prosjekter, med forslag til frilanser. Koble, opprett ny eller merk som «Ikke frilanser».",
          featureFlag: "feature_freelancer_projects",
        },
      ],
    },
  ],
};
